const API_KEY = "Kdxumv063JBxqGgXHerYACoPQRiyJjlS19W3f80";
const BASE_URL = "https://apis.postcode-jp.com/api/v5";

export const fetchPostCode = async (postCode) => {
  try {
    const queryUrl = `apikey=${API_KEY}`;
    const url = `${BASE_URL}/postcodes/${postCode}/?${queryUrl}`;
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (e) {
    console.log(e);
  }
};
